import { render, staticRenderFns } from "./ExProficiencyBadgeHolderFrame.vue?vue&type=template&id=090a66d6"
import script from "./ExProficiencyBadgeHolderFrame.vue?vue&type=script&lang=js"
export * from "./ExProficiencyBadgeHolderFrame.vue?vue&type=script&lang=js"
import style0 from "./ExProficiencyBadgeHolderFrame.vue?vue&type=style&index=0&id=090a66d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports